<div class="tw-bg-black tw-opacity-80 tw-fixed tw-inset-0 tw-z-40" (click)="onClose()"></div>
<div class="tw-fixed tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2 tw-z-50">
  <div class="tw-bg-white tw-z-50 tw-p-6 tw-w-[312px] tw-h-[352px] tw-rounded-6 tw-font-body tw-relative">
    <!-- close btn-->
    <img (click)="onClose()" class="tw-w-6 tw-aspect-square tw-absolute tw-right-3 tw-top-3" src="/assets/icons/close-btn-black-cross-gray-bg.svg" alt="close popup"/>
    <!-- bell animation -->
    <div class="tw-mb-9 tw-pt-1">
      <!-- gif-->
      <div class="tw-mb-3">
        <img class="tw-w-[104px] tw-mx-auto" src="/assets/gifs/notification-green-bell.gif" alt="notification bell animations"/>
      </div>
      <p class="tw-text-600 tw-text-center">
        <span class="tw-font-bold">Want to stay updated</span><br/><span>on your orders, routine, check-ups &amp; more?</span>
      </p>
    </div>
    <button class="tw-rounded-2 tw-bg-teal-600 tw-text-white tw-font-body tw-text-300 tw-normal-case tw-w-full tw-p-2 tw-h-10 tw-font-bold tw-mb-4" (click)="onEnable()">Yes, enable notifications</button>
    <div class="tw-text-gray-400 tw-font-body tw-text-300 tw-capitalize tw-w-full tw-font-bold tw-p-0 tw-text-center" (click)="onClose()">Maybe later</div>
  </div>
</div>
